import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name list-chevrons-down-up
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTUgMTggMy0zIDMgMyIgLz4KICA8cGF0aCBkPSJtMTUgNiAzIDMgMy0zIiAvPgogIDxwYXRoIGQ9Ik0zIDEyaDgiIC8+CiAgPHBhdGggZD0iTTMgMThoOCIgLz4KICA8cGF0aCBkPSJNMyA2aDgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/list-chevrons-down-up
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ListChevronsDownUp: IconNode = [
  ['path', { d: 'm15 18 3-3 3 3' }],
  ['path', { d: 'm15 6 3 3 3-3' }],
  ['path', { d: 'M3 12h8' }],
  ['path', { d: 'M3 18h8' }],
  ['path', { d: 'M3 6h8' }],
];

export default ListChevronsDownUp;
